module.exports = __webpack_public_path__ + "img/bar33.3bcc1ca2.jpg";